module.exports = __webpack_public_path__ + "edf7cfc4a270b60935d9ed150dc97510.jpg";